// extracted by mini-css-extract-plugin
export default {"themeSwitch":"themeSwitch__Ls-dL","light":"light__qZz7x","dark":"dark__kMLcJ","sun":"sun__7v7Jt","moon":"moon__si171"};